<template>
  <div class="modal-dialog" role="document" v-cloak>
    <div class="modal-content modal-dialog-centered" v-click-outside="dismiss">
      <div class="modal-icon bg-gradient">
        <div class="icon text-primary bg-white">
          <div v-html="icons[message.type]"></div>
        </div>
      </div>
      <div class="modal-header">
        <h5 class="modal-title" id="modalTitle" style="text-align:center" >{{$t(message.title)}}</h5>
      </div>
      <div class="modal-body text-center" v-html="$t(message.text)"></div>
      <div
        class="modal-body points text-primary text-uppercase"
        v-html="message.points"
        style="font-size: 2rem;font-weight: bold;"
      ></div>
      <div class="modal-body text-center" v-html="message.underpoints"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="dismiss">OK</button>
      </div>
    </div>
  </div>
</template>
<script>
import iconInstantWin from "../../../assets/svg/fnz_instant-win.svg";
import iconPhone from "../../../assets/svg/fnz_phone.svg";
import iconWaiting from "../../../assets/svg/fnz_waiting.svg";
import iconCard from "../../../assets/svg/fnz_card.svg";
import iconCongratulation from "../../../assets/svg/fnz_congratulation.svg";
import iconIze from "../../../assets/svg/fnz_ize.svg";
import iconOk from "../../../assets/svg/fnz_ok.svg";
import iconError from "../../../assets/svg/fnz_error.svg";
import iconSuccess from "../../../assets/svg/fnz_success.svg";
import iconCoins from "../../../assets/svg/fnz_ize.svg";
export default {
  props: ["message"],
  data() {
    return {
      icons: {
        instantwin: iconInstantWin,
        phone: iconPhone,
        waiting: iconWaiting,
        card: iconCard,
        congratulation: iconCongratulation,
        ize: iconIze,
        ok: iconOk,
        error: iconError,
        success: iconSuccess,
        coins: iconCoins
      }
    };
  },
  methods: {
    dismiss() {
      this.$emit("dismiss");
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${
            binding.expression
          }' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
<style scoped>
.modal-content {
  position: relative;
  padding-top: 51px;
}
.modal-header,
.modal-footer {
  border: 0;
}
.modal-header {
  padding-bottom: 0;
}
.modal-body {
  padding-top: 0;
}
.modal-icon {
  position: absolute;
  top: 0;
  left: 50%;
  height: auto;
  width: 102px;
  margin-left: -51px;
  margin-top: -51px;
  padding: 4px;
  overflow: hidden;
  border-radius: 50%;
}
.modal-icon > .icon {
  fill: currentColor;
  border-radius: 50%;
  overflow: hidden;
  height: 94px;
  width: 94px;
  line-height: 94px;
  text-align: center;
}
.modal-icon > .icon > div {
  fill: currentColor;
  height: 64px;
  display: block;
  margin: 15px auto;
  width: 64px;
}
.modal-icon > .icon > div > svg {
  fill: currentColor;
  height: 64px;
  display: block;
  margin: 0 auto;
}
</style>